import { getRuntimeConfig } from '@halo/_utils/runtime-config'

export const VALID_DOMAIN_REGEX =
    /^(?:http[s]?:\/\/)?(?:localhost|(?:(?:[a-z](?:(?:[a-z0-9]*?[-_]?[a-z0-9]*)?[a-z0-9]){0,4})\.){1,4}[a-z]{2,24})$/i
export const VALID_URL_REGEX =
    /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/i

export const APP_BASE_ROUTE = '/'
export const APP_PREAUTH_ROUTE = '/login'
export const AUTH_REDIRECT_PARAM = 'redirect'
export const REF_QUERY_PARAM = 'ref'

export const MAX_SESSION_LENGTH_HOURS = parseInt(String(process.env.MAX_SESSION_LENGTH_HOURS || 24), 10)
export const WARNING_THRESHOLD_SECONDS = 300

// Auth0 is per-environment, so it comes from the runtime config block rather than the bundle.
// These were previously selected by `process.env.NODE_ENV`, which conflated the compile mode
// with the deployed environment: a production-optimised build of dev pointed the login flow at
// the production tenant.
export const AUTH0_AUTH_ROUTE_BASE = 'identity.'
export const AUTHORIZE_ROUTE = `${getRuntimeConfig().PLATFORM_ROOT_DOMAIN}/authorize`
export const LOGOUT_ROUTE = `${getRuntimeConfig().PLATFORM_ROOT_DOMAIN}/v2/logout`
export const AUTH0_TENANT_ID = getRuntimeConfig().AUTH0_TENANT_ID
export const AUTH0_CLIENT_ID = getRuntimeConfig().AUTH0_CLIENT_ID
export const AUTH0_PLATFORM_REDIRECT_PATHNAME = '/authorize'
export const AUTH0_STATE_SESSION_KEY = 'sw_a0st'

export const PLATFORM_CAN_ACCESS_HALO = 'PLATFORM_CAN_ACCESS_HALO'
export const FEAT_SDK_EVENT_ONLY_DOMAINS = 'FEAT_SDK_EVENT_ONLY_DOMAINS'
export const FEAT_CHANNEL_ANDROID = 'FEAT_CHANNEL_ANDROID'
export const FEAT_CHANNEL_IOS = 'FEAT_CHANNEL_IOS'

export const SUPPORTED_BILLING_CURRENCIES = [
    { label: 'Canadian Dollars', value: 'CAD', symbol: 'C$' },
    { label: 'Euros', value: 'EUR', symbol: '€' },
    { label: 'British Pounds', value: 'GBP', symbol: '£' },
    { label: 'US Dollars', value: 'USD', symbol: '$' },
]

export const DEFAULT_DRAWER_FORM_ITEM_LAYOUT = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
    },
}

// Horizontal layout used by read-only "settings" Wells (Organization, Domain).
// Mirrors pufferfish's SETTINGS_WELL_FORM_LAYOUT so the two apps render the
// same label/value rhythm inside ghost subsections.
export const SETTINGS_WELL_FORM_LAYOUT = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
}

export const APPLICATION_VERSION = process.env.APPLICATION_VERSION || 'local'

export const DEFAULT_DOMAIN_INDUSTRY_ID = 1